export interface TapBrandProps {
  /** Logo glyph height in px. */
  size?: number
  showWordmark?: boolean
  /** Tailwind text-size class for the wordmark (login uses text-2xl, the
   *  sidebar/topbar use the demo's compact text-base). */
  wordmarkClassName?: string
}

/** TAP hexagon logo + wordmark. Extracted from the demo's login branding. */
export function TapBrand({
  size = 34,
  showWordmark = true,
  wordmarkClassName = 'text-2xl',
}: TapBrandProps) {
  return (
    <div className="flex items-center gap-2.5">
      <svg width={size} height={size} viewBox="0 0 22 22" fill="none" aria-hidden>
        <polygon
          points="11,2 20,7 20,15 11,20 2,15 2,7"
          fill="none"
          stroke="var(--accent-primary)"
          strokeWidth="1.5"
        />
        <polygon
          points="11,5.5 17,8.75 17,13.25 11,16.5 5,13.25 5,8.75"
          fill="var(--accent-primary-dim)"
          stroke="var(--accent-primary)"
          strokeWidth="1"
        />
        <circle cx="11" cy="11" r="2" fill="var(--accent-primary)" />
      </svg>
      {showWordmark && (
        <span className={`font-mono ${wordmarkClassName} font-semibold tracking-[0.05em] text-accent`}>
          TAP
        </span>
      )}
    </div>
  )
}
